import React, { useState } from 'react';
import { Avatar } from '../ui/avatar';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { FeatherUser, FeatherChevronDown, FeatherChevronUp, FeatherFile, FeatherClock, FeatherCheckCircle } from '../ui/icons';
import TaskHistoryTimeline from './TaskHistoryTimeline';
import './UserAllocationCard.css';

const UserAllocationCard = ({ user, taskDetails, taskStats, closedVsAttempted }) => {
    const [expanded, setExpanded] = useState(false);

    const getStatusVariant = (status) => {
        switch (status?.toLowerCase()) {
            case 'completed':
            case 'released':
                return 'success';
            case 'in-progress':
                return 'warning';
            default:
                return 'neutral';
        }
    };

    return (
        <div className="user-allocation-card">
            <div className="user-allocation-card-header" onClick={() => setExpanded(!expanded)}>
                <div className="user-allocation-card-user-info">
                    <Avatar size="medium">
                        {user.name?.charAt(0) || 'U'}
                    </Avatar>
                    <div>
                        <div className="user-allocation-card-name">{user.name}</div>
                        {user.email && (
                            <div className="user-allocation-card-email">{user.email}</div>
                        )}
                    </div>
                </div>
                <div className="user-allocation-card-stats-summary">
                    <div className="user-allocation-stat-item">
                        <span className="user-allocation-stat-label">Tasks</span>
                        <span className="user-allocation-stat-value">{taskStats.totalTasks}</span>
                    </div>
                    <div className="user-allocation-stat-item">
                        <span className="user-allocation-stat-label">Attempts</span>
                        <span className="user-allocation-stat-value">{taskStats.totalAttempts}</span>
                    </div>
                    <div className="user-allocation-stat-item">
                        <span className="user-allocation-stat-label">Closed</span>
                        <span className="user-allocation-stat-value">{taskStats.closedTasks}</span>
                    </div>
                </div>
                <Button variant="neutral-tertiary" icon={expanded ? <FeatherChevronUp size={16} /> : <FeatherChevronDown size={16} />}>
                    {expanded ? 'Collapse' : 'Expand'}
                </Button>
            </div>

            {expanded && (
                <div className="user-allocation-card-content">
                    <div className="user-allocation-card-stats-grid">
                        <div className="user-allocation-stat-card">
                            <div className="user-allocation-stat-card-label">Closed vs Attempted</div>
                            <div className="user-allocation-stat-card-value">
                                {closedVsAttempted.closed} / {closedVsAttempted.attempted}
                            </div>
                            <div className="user-allocation-stat-card-ratio">
                                {closedVsAttempted.ratio}% closed
                            </div>
                        </div>
                        <div className="user-allocation-stat-card">
                            <div className="user-allocation-stat-card-label">In Progress</div>
                            <div className="user-allocation-stat-card-value">{taskStats.inProgress}</div>
                        </div>
                        <div className="user-allocation-stat-card">
                            <div className="user-allocation-stat-card-label">Open</div>
                            <div className="user-allocation-stat-card-value">{taskStats.open}</div>
                        </div>
                        <div className="user-allocation-stat-card">
                            <div className="user-allocation-stat-card-label">Completed</div>
                            <div className="user-allocation-stat-card-value">{taskStats.completed}</div>
                        </div>
                        <div className="user-allocation-stat-card">
                            <div className="user-allocation-stat-card-label">Total Hours</div>
                            <div className="user-allocation-stat-card-value">{taskStats.totalHours.toFixed(1)}h</div>
                        </div>
                    </div>

                    <div className="user-allocation-card-tasks">
                        <h4 className="user-allocation-card-tasks-title">Task Details</h4>
                        {taskDetails && taskDetails.length > 0 ? (
                            taskDetails.map((task, index) => (
                                <div key={task.id || index} className="user-allocation-task-item">
                                    <div className="user-allocation-task-header">
                                        <div className="user-allocation-task-title-section">
                                            <FeatherFile size={16} className="user-allocation-task-icon" />
                                            <div>
                                                <div className="user-allocation-task-title">{task.title}</div>
                                                {task.description && (
                                                    <div className="user-allocation-task-description">{task.description}</div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="user-allocation-task-badges">
                                            <Badge variant={getStatusVariant(task.currentStatus)}>
                                                {task.currentStatus}
                                            </Badge>
                                            <Badge variant="neutral">
                                                {task.attempts} {task.attempts === 1 ? 'attempt' : 'attempts'}
                                            </Badge>
                                            {task.totalHours > 0 && (
                                                <Badge variant="neutral">
                                                    {task.totalHours.toFixed(1)}h
                                                </Badge>
                                            )}
                                        </div>
                                    </div>
                                    {task.history && task.history.length > 0 && (
                                        <TaskHistoryTimeline history={task.history} />
                                    )}
                                </div>
                            ))
                        ) : (
                            <div className="user-allocation-card-empty">No task details available</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserAllocationCard;

